package com.parmartechnologies.core.feature.product.model

import com.parmartechnologies.core.extension.BaseDataClass
import com.parmartechnologies.core.feature.currency.model.Currency
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.ExperimentalTime

@Serializable
data class ProductPrice @OptIn(ExperimentalTime::class) constructor(
    @SerialName("hsn") var hsn: String = "",
    @SerialName("tax_included") var taxIncluded: Int = 0,
    @SerialName("sgst") var SGST: Double = 0.0,
    @SerialName("cgst") var CGST: Double = 0.0,
    @SerialName("igst") var IGST: Double = 0.0,
    @SerialName("cess") var CESS: Double = 0.0,
    @SerialName("vat") var VAT: Double = 0.0,
    @SerialName("other_tax") var OtherTax: Double = 0.0,
    @SerialName("discount") var Discount: Double = 0.0,
    @SerialName("mrp") var MRP: Double = 0.0,
    @SerialName("sale_price") var SalePrice: Double = 0.0,
    @SerialName("price") var Price: Double = 0.0,
    @SerialName("cost_price") var CostPrice: Double = 0.0,
    @SerialName("final_price") var FinalPrice: Double = 0.0,
    @SerialName("tax") var Tax: Double = 0.0,
    @SerialName("currency") var currency: Currency? = null,
): BaseDataClass()

//